import { lightGrey } from "constants/colors";
import {
  BREAKPOINT_DESKTOP_XL,
  CHART_MAX_WIDTH,
  TILE_WIDTH_PX_SM,
} from "constants/constants";
import { css, createGlobalStyle } from "styled-components/macro";
import { GROUP_METRICS_FLOATER_HEIGHT } from "../GroupMetrics/GroupMetricsStyles";
import {
  GROUP_METRIC_HEIGHT,
  GROUP_METRIC_WIDTH,
} from "../GroupMetrics/groupMetricsUtils";
import {
  TAGHIGHLIGHT_BACKDROP_HEIGHT,
  TAGHIGHLIGHT_SKU_OPERATOR_TIMELINE_ROW_GAP,
} from "../HubletView/SingleTimeline/TagHighlightTimelineBackdrop";
import {
  RETROTAG_POPPER_HEIGHT,
  RETROTAG_POPPER_WIDTH,
} from "../Timeline/RetrotagPopper/RetrotagPopperStyles";

export const getRangeSelectorResponsiveStyles = (scale: number) => css`
  .Card_TodaysProduction {
    .cardContent > .spacer {
      height: ${20}px;
    }
  }
  .Card_RangeSelector {
    [class*="CardTopbarStyles"] {
      height: ${scale * 16}px;
      background: none;
    }
    .cardContent {
      padding-bottom: 0;
      padding: ${scale * 2}px ${scale * 6}px ${scale * 6}px;
    }
    .cardConfigControls {
      right: ${scale * 3}px;
    }
    [class*="DateAndShiftPickerStyles"] {
      padding: 0;
      .leftSide {
        .rangeName {
          font-size: ${scale * 16}px;
          line-height: ${scale * 24}px;
        }
        .range {
          font-size: ${scale * 12}px;
          line-height: ${scale * 20}px;
        }
        .shiftButton,
        .btn24Hours {
          height: ${scale * 48}px;
        }
        .shiftButton {
          width: ${scale * 148}px;
          &:not(:last-child) {
            margin-right: ${scale * 8}px;
          }
        }
        .btn24Hours {
          width: ${scale * 128}px;
        }
        .MuiDivider-vertical {
          height: ${scale * 16}px;
          margin-right: ${scale * 5}px;
          margin-left: ${scale * 3}px;
        }
      }
      .rightSide {
        .btnDatePicker {
          height: ${scale * 48}px;
          width: ${scale * 228}px;
          padding: 12px ${scale * 16}px 12px ${scale * 12}px;
        }
        .btnDatePickerText {
          font-size: ${scale * 9}px;
        }
        .offsetAndTimezoneIndicator {
          font-size: ${scale * 9}px;
          top: ${scale * 5}px;
          left: ${scale * 6}px;
        }
        .date {
          font-size: ${scale * 15}px;
        }
        .MuiSvgIcon-root {
          width: ${scale * 22}px;
          height: ${scale * 22}px;
        }
        .btnForward,
        .btnBack {
          width: ${scale * 48}px;
          height: ${scale * 48}px;
          .MuiSvgIcon-root {
            width: ${scale * 36}px;
            height: ${scale * 36}px;
          }
        }
      }
    }
  }

  .react-calendar.datePickerCalendar {
    transform: scale(${scale}) !important;
    transform-origin: top right !important;
  }
`;

export const getDashboardCardsResponsiveStyles = (scale: number) => css`
  .cardTitle {
    font-size: ${scale * 14}px;
    margin-top: ${scale * 4}px;
  }
  .cardContent {
    padding-bottom: ${scale * 32}px;
  }
  .cardConfigControls {
    transform-origin: top right;
    .btnMoreMenu,
    .btnOpenConfig,
    .btnRangeSelectorConfig {
      .MuiSvgIcon-root {
        width: ${scale * 24}px;
        height: ${scale * 24}px;
      }
    }
    .btnOpenConfig {
      margin-top: ${scale * 2}px;
      margin-right: ${scale * 4}px;
    }
  }
  [class*="CardTopbarStyles"] {
    height: ${scale * 28}px;
    .btnCollapse {
      &,
      .MuiSvgIcon-root {
        width: ${scale * 24}px;
        height: ${scale * 24}px;
      }
    }
  }
  [class*="CardWithControls__CardStyles"] {
    width: auto;
  }
`;

export const getGroupMetricsResponsiveStyles = (scale: number) => css`
  [class*="GroupMetricsStyles"] {
    padding: 0px 0 40px 0;
    .metrics {
      height: ${scale * GROUP_METRIC_HEIGHT}px;
    }
    .metricsScrollContainer {
      height: ${scale * GROUP_METRICS_FLOATER_HEIGHT}px;
    }
    .preferredMetricFloater {
      height: ${scale * 50}px;
      width: ${scale * 86}px;
      display: none;
    }
    .metricDiv.preferred {
      background: ${lightGrey};
    }
    .metricDiv.extraHeight {
      height: fit-content;
    }
    [class*="GroupMetricStyles"] {
      width: fit-content;
      min-width: ${scale * GROUP_METRIC_WIDTH.sm}px;
      max-width: ${scale * (GROUP_METRIC_WIDTH.sm + 12)}px;
      padding: 0 1.5em;
      margin: 0 ${scale * 10}px;
      border-radius: ${scale * 6}px;
      .btnGroupMetrics {
        padding: 0 1.5em !important;
        margin: 0 -1.5em !important;
        border-radius: ${scale * 6}px;
      }
      .metricTitle {
        font-size: ${scale * 14}px;
      }
      [class*="MetricValueStyles"] {
        font-size: ${scale * 18}px;
      }
      [class*="SingleGroupMetric__MetricTitleStyles"] {
        .words {
          max-width: ${scale * GROUP_METRIC_WIDTH.sm}px;
        }
      }
      [class*="SingleGroupMetric__HelpButtonStyles"] {
        width: ${scale * 16}px;
        height: ${scale * 16}px;
        /* margin-right: ${scale * -5}px; */
        transform: translateX(${scale * 5}px);

        svg {
          width: ${scale * 14}px;
          height: ${scale * 14}px;
        }
      }
    }
  }
`;

export const getTrendChartResponsiveStyles = (scale: number) => css`
  [class*="TrendChartLoaderSkeleton__TrendChartLoaderSkeletonStyles"] {
    width: ${100 - scale * 25}%;
    transform: scale(${scale * 0.75});
    transform-origin: center center;
    margin: auto;
    justify-content: center;
    .trendChartBar {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .barstack {
    width: ${scale * 48}px;
    padding-right: 0;
    padding-left: 0;
  }
  [class*="TrendChartCenterMetricStyles"] {
    font-size: ${scale * 14}px;
    min-height: ${scale * 40}px;
  }
  .btnTrendChartBar {
    width: ${scale * 71}px;
  }
  [class*="TrendChartBarStyles"] {
    min-width: ${scale * 78}px;
    max-width: ${scale * 78}px;
    [class*="TrendChartBarCountStyles"] {
      height: ${scale * 40}px;
      font-size: ${scale * 18}px;
      .outputLabel {
        font-size: ${scale * 12}px;
      }
    }
  }
  .btnTrendChartBar {
    padding-top: ${scale * 10}px;
  }
  .topBarstack {
    padding-top: ${scale * 18}px;
  }
  [class*="BarTitleStyles"] {
    height: ${scale * 40}px;
    font-size: ${scale * 16}px;
    .titleLabel {
      line-height: ${scale * 16}px;
    }
    .outlinedWrapper {
      width: ${scale * 60}px;
      height: ${scale * 44}px;
    }
    .timeStart {
      margin-top: ${scale * 1}px;
      margin-bottom: ${scale * 2}px;
    }
  }
`;

export const getOverallBarstackResponsiveStyles = (scale: number) => css`
  [class*="OverallBarstackLoaderSkeleton__LoaderAnimationStyles"] {
    .leftStack,
    .rightStack {
      height: ${scale * 41}px;
    }
  }
  [class*="OverallBarstackStyles"] {
    height: ${scale * 41}px;
  }
  [class*="OverallBarstackWrapperStyles"] {
    max-width: min(${scale * CHART_MAX_WIDTH}px, 80%);
    .overallBarstack {
      height: ${scale * 41}px;
    }
    [data-component-name="Overall Barstack"].loaderSkeleton {
      height: ${scale * 41}px;
    }
    .barstackSpacer {
      height: ${scale * 45}px;
      width: ${scale * 20}px;
      border-left: ${scale * 2}px solid black;
      border-right: ${scale * 2}px solid black;
    }
  }
`;

export const getTimelineChartResponsiveStyles = (
  scale: number,
  isMultiTimeline = false
) => css`
  &&& {
    .Card_Timeline {
      .cardContent {
        padding-bottom: ${scale * 0}px;
        #timelineStyles.detailsPage {
          min-height: ${scale * 380}px;
        }
      }
    }
    .Card_GroupTimeline {
      .timelineLeftSide {
        padding-top: ${scale ** 0.5 * 81}px;
      }
    }
  }
  [class*="TimelinesStyles"] {
    /* everything in TimelinesStyles gets scaled by p.scale * 2 */
    .timeline-overflow-wrapper {
      transform: scaleY(${scale * 1});
      transform-origin: top;
    }
    [class*="TimeAxisStyles"] {
      padding-bottom: ${scale * 16}px;
      margin-top: ${scale * -8}px;
      &.detailsPage {
        height: ${scale * 42}px;
        .tag-highlight {
          transform: translateY(${scale * 8.2}px);
        }
        &.collapsed {
          height: ${scale * 92}px;
          .tag-highlight {
            transform: translateY(${scale * 6}px);
          }
        }
      }
    }
    [class*="PopperContentStyles"] {
      .paper {
        border-radius: ${scale * 5}px;
        padding: ${scale * 25}px ${scale * 35}px ${scale * 10}px;
        height: ${scale * RETROTAG_POPPER_HEIGHT}px;
        width: ${scale * RETROTAG_POPPER_WIDTH}px;
      }
    }
    .tick text {
      transform: scaleX(${scale * 1});
    }
    [class*="ShiftBoundariesIndicators__StyledForeignObject"] .MuiChip-root {
      transform: scaleX(${scale * 1}) translateX(${scale * 12}px);
    }
    .nowIndicator > g text {
      transform: scaleY(${1 / scale}) translateY(14px);
      font-size: ${scale * 14}px;
    }
  }
  .btnExpandCollapseTimeline {
    right: ${scale * 18}px;
    bottom: ${scale * 18}px;
    .MuiButton-startIcon {
      transform: scale(${scale / 2});
      transform-origin: right;
    }
  }
  [data-component-name="Time Axis Controls"] {
    transform: scale(${scale * 0.75})
      translate(${scale * -8}px, ${scale * -4}px);
    transform-origin: top right;
  }
  [data-component-name="TimelineTooltip"] {
    ${isMultiTimeline
      ? // multi-timeline pages (Trends, Timeline)
        css`
          transform: scaleY(${scale * 0.75}) scaleX(${scale * 1.25});
          transform: scaleY(${scale * 0.8}) scaleX(${scale})
            translateY(${scale * 32}px);
          &.upwardPointing {
            transform: scaleY(${scale * 0.8}) scaleX(${scale})
              translateY(${scale * 10}px);
          }
          @media (min-width: 2400px) {
            transform: scaleY(${scale * 0.7}) scaleX(${scale * 1})
              translateY(${scale * 36}px);
            &.upwardPointing {
              transform: scaleY(${scale * 0.7}) scaleX(${scale * 1})
                translateY(${scale * -0}px);
            }
          }
          @media (min-width: 3000px) {
            transform: scaleY(${scale ** 0.5 * 0.56})
              scaleX(${scale ** 0.5 * 1.2}) translateY(${scale ** 0.5 * 110}px);
            &.upwardPointing {
              transform: scaleY(${scale ** 0.5 * 0.56})
                scaleX(${scale ** 0.5 * 1.2})
                translateY(${scale ** 0.5 * -46}px);
            }
          }
          @media (min-width: 3600px) {
            transform: scaleY(${scale ** 0.5 * 0.5})
              scaleX(${scale ** 0.5 * 1.3}) translateY(${scale ** 0.5 * 128}px);
            &.upwardPointing {
              transform: scaleY(${scale ** 0.5 * 0.5})
                scaleX(${scale ** 0.5 * 1.3})
                translateY(${scale ** 0.5 * -128}px);
            }
          }
          @media (min-width: 3800px) {
            transform: scaleY(${scale ** 0.5 * 0.5})
              scaleX(${scale ** 0.5 * 1.3}) translateY(${scale ** 0.5 * 130}px);
            &.upwardPointing {
              transform: scaleY(${scale ** 0.5 * 0.5})
                scaleX(${scale ** 0.5 * 1.3})
                translateY(${scale ** 0.5 * -68}px);
            }
          }
        `
      : // single-timeline pages (Hublet, TimelineOnlyPage)
        css`
          transform: scaleY(${scale * 0.8}) scaleX(${scale})
            translateY(${scale * 32}px);
          &.upwardPointing {
            transform: scaleY(${scale * 0.8}) scaleX(${scale})
              translateY(${scale * 10}px);
          }
          @media (min-width: 2400px) {
            transform: scaleY(${scale * 0.7}) scaleX(${scale * 1})
              translateY(${scale * 36}px);
            &.upwardPointing {
              transform: scaleY(${scale * 0.7}) scaleX(${scale * 1})
                translateY(${scale * -0}px);
            }
          }
          @media (min-width: 3000px) {
            transform: scaleY(${scale ** 0.5 * 0.56})
              scaleX(${scale ** 0.5 * 1.2}) translateY(${scale ** 0.5 * 110}px);
            &.upwardPointing {
              transform: scaleY(${scale ** 0.5 * 0.56})
                scaleX(${scale ** 0.5 * 1.2})
                translateY(${scale ** 0.5 * -46}px);
            }
          }
          @media (min-width: 3600px) {
            transform: scaleY(${scale ** 0.5 * 0.5})
              scaleX(${scale ** 0.5 * 1.3}) translateY(${scale ** 0.5 * 128}px);
            &.upwardPointing {
              transform: scaleY(${scale ** 0.5 * 0.5})
                scaleX(${scale ** 0.5 * 1.3})
                translateY(${scale ** 0.5 * -128}px);
            }
          }
          @media (min-width: 3800px) {
            transform: scaleY(${scale ** 0.5 * 0.5})
              scaleX(${scale ** 0.5 * 1.3}) translateY(${scale ** 0.5 * 130}px);
            &.upwardPointing {
              transform: scaleY(${scale ** 0.5 * 0.5})
                scaleX(${scale ** 0.5 * 1.3})
                translateY(${scale ** 0.5 * -68}px);
            }
          }
          @media (min-width: 4200px) {
            transform: scaleY(${scale ** 0.5 * 0.5})
              scaleX(${scale ** 0.5 * 1.4}) translateY(${scale ** 0.5 * 156}px);
            &.upwardPointing {
              transform: scaleY(${scale ** 0.5 * 0.5})
                scaleX(${scale ** 0.5 * 1.4})
                translateY(${scale ** 0.5 * -92}px);
            }
          }
        `}
    transform-origin: bottom;
    &.upwardPointing {
      transform-origin: top;
    }
    .MuiTabs-indicator {
      top: 0;
      transform: scaleX(${1 / scale});
      transform-origin: left;
    }
    .timelineTooltipTabs.tab-1 .MuiTabs-indicator {
      left: ${scale * 48}px !important;
    }
  }
  [class*="HighlightTagsSelectorStyles"] {
    padding: ${scale * 18}px;
    .highlightedTagsChips {
      margin-left: ${scale * -8}px;
      margin-bottom: ${scale * 12}px;
    }
  }
  [class*="HighlightTagsSelectorStyles__HighlightedTagIndicatorStyles"] {
    padding: ${scale * 4}px;
    .MuiIconButton-root {
      width: ${scale * 19}px;
      height: ${scale * 24}px;
      svg {
        width: ${scale * 19}px;
      }
    }
    .colorIndicator {
      width: ${scale * 6}px;
      height: ${scale * 14}px;
      margin-right: ${scale * 6}px;
    }
  }
  [class*="HighlightTagsSelectorStyles"] .btnTagHighlight,
  .btnExpandCollapseTimeline .MuiButtonBase-root,
  .highlighted-tag-text {
    font-size: ${scale * 12}px;
  }

  [class*="TimelineCardControls__ControlsStyles"]
    [class*="CollapsibleConfigStyles"] {
    transform: scale(${scale});
    transform-origin: top right;
  }
  [class*="TimelinesStyles__ProcessesColumnStyles"] {
    min-width: ${scale * 75}px;
    .metricContainer {
      height: ${scale * 40}px;
      margin-bottom: ${scale * 2}px;
    }
    .title.metricTitle {
      font-size: ${scale * 15}px;
      top: ${scale * -22}px;
    }
    [class*="ProcessMetrics__MetricStyles"] {
      font-size: ${scale * 10}pt;
    }
  }
  [aria-controls="highlight-tags-menu"] {
    z-index: 8;
  }
  [class*="TagHighlightTimelineBackdrop"].collapsed {
    margin-top: ${3}px;
  }
  div[class*="TagHighlightTimelineBackdrop"].TagHightlightBackdrop {
    height: ${scale * TAGHIGHLIGHT_BACKDROP_HEIGHT}px !important;
    margin-top: ${scale * 50}px !important;
    .placeholderText {
      font-size: ${scale * 12}px;
    }
    &.collapsed {
      margin-top: ${3}px !important;
    }
  }
  [class*="BtnExpandCollapseTimeline__BtnExpandCollapseTimelineStyles"],
  .btnTagHighlight {
    height: ${scale * 30}px;
  }
  .belowSingleTimelineSpacer {
    [class*="SkuOperatorTimelineBackdrop"] {
      height: ${scale * TAGHIGHLIGHT_BACKDROP_HEIGHT}px;
      margin-top: ${scale * TAGHIGHLIGHT_SKU_OPERATOR_TIMELINE_ROW_GAP}px;
    }
  }
  #ticks-tooltip,
  #ticks-tooltip-arrow {
    transform: scaleX(${scale});
  }

  [class*="SubTimelinesStyles"] {
    .title {
      .icon,
      .text {
        transform: scaleX(${scale});
        transform-origin: left;
      }
      .text {
        margin-left: ${scale * 8}px;
        @media (min-width: 3000px) {
          margin-left: ${scale * 16}px;
        }
      }
    }
  }
  ${isMultiTimeline
    ? css`
        #timelineStyles {
          margin-top: ${scale * 40}px;
        }
        [class*="TimelinesStyles__TimeAxisStyles"].TimeAxisStyles {
          padding-top: ${scale * 24}px;
        }
        [data-component-name="Time Axis Controls"] {
          transform: scale(${scale * 0.75})
            translate(${scale * -8}px, ${scale * -22}px);
          transform-origin: bottom right;
        }
        [class*="TimelinesStyles__ProcessesColumnStyles"].machinesColumn {
          width: ${scale * 92}px;
          [class*="ProcessNameLink__ProcessNameLinkStyles"] {
            width: ${scale * 100}px;
          }
          .machineTitle {
            font-size: ${scale * 15}px;
            top: ${scale * -22}px;
          }
          .processName {
            font-size: ${scale * 17}px;
          }
          .processNameLinkWrapper {
            height: ${scale * 42}px !important;
          }
        }
        .timelineSpacer {
          width: ${scale * 20}px;
          min-width: ${scale * 20}px;
        }
      `
    : ""}
`;

export const getTimelineChartResponsiveGlobalStyles = (scale: number) => css`
  [class*="RetrotagPopperStyles"] {
    .paper {
      border-radius: ${scale * 5}px;
      padding: ${scale * 25}px ${scale * 35}px ${scale * 10}px;
      height: ${scale * RETROTAG_POPPER_HEIGHT}px;
      width: ${scale * RETROTAG_POPPER_WIDTH}px;

      .bottomButtons {
        bottom: ${scale * 10}px;
      }
      .formTitle {
        font-size: ${scale * 17}px;
      }
      [class*="TagTreeSelect"] .MuiButton-root {
        font-size: ${scale * 14}px;
      }
      .btnClose {
        top: ${scale * -10}px;
        right: ${scale * -10}px;
        .MuiButtonBase-root,
        .MuiTouchRipple-root {
          width: ${scale * 48}px;
          height: ${scale * 48}px;
        }
        .MuiSvgIcon-root {
          width: ${scale * 24}px;
          height: ${scale * 24}px;
        }
      }
      .startEndTimesDisplay {
        .MuiButtonBase-root {
          width: ${scale * 24}px;
          height: ${scale * 24}px;
        }
      }
    }
    .space-10 {
      height: ${scale * 10}px !important;
    }
    .space-15 {
      height: ${scale * 15}px !important;
    }
    .space-25 {
      height: ${scale * 25}px !important;
    }
    .space-30 {
      height: ${scale * 30}px !important;
    }
    &&& * {
      font-size: ${scale * 12}px;
    }
  }
  [class*="TagsGridModalContentStyles"] {
    transform: scale(${scale});
  }
  #highlight-tags-menu .MuiPopover-paper {
    transform: scale(${1 / scale ** 0.3}) !important;
  }
`;

export const getPnlPopupChartResponsiveStyles = (scale: number) => css`
  .pnlChartPopupContent {
    max-width: ${scale * CHART_MAX_WIDTH}px;
    .content {
      padding: ${scale * 32}px ${scale * 72}px ${scale * 56}px;
    }
  }
  [data-component-name="PnL Popup"] {
    .metricsScrollContainer .metrics {
      height: ${scale * 60}px;
    }
    margin-top: ${scale * 38}px;
    .btnCloseWrapper {
      top: ${scale * 8}px;
      right: ${scale * 8}px;
      .MuiIconButton-root,
      .MuiSvgIcon-root {
        width: ${scale * 48}px;
        height: ${scale * 48}px;
      }
    }
  }
  &&& {
    [data-component-name="PnL Popup"] {
      border-radius: ${scale * 4}px;
    }
    [class*="PnlPopupTitleBar__PnlPopupTitleBarStyles"] {
      height: ${scale * 64}px;
      border-top-left-radius: ${scale * 4}px;
      border-top-right-radius: ${scale * 4}px;
      .dateTimeWrapper {
        font-size: ${scale * 24}px;
        padding: ${0}px ${scale * 16}px;
      }
      .dateTime {
        font-size: ${scale * 30}px;
      }
    }
  }
`;
export const getPnlChartResponsiveStyles = (scale: number) => css`
  [data-component-name="PnL Chart"] {
    max-width: ${scale * CHART_MAX_WIDTH}px;
    .categoryTitle.leftMost {
      &:before {
        width: ${scale * 12}px;
      }
      &:after {
        width: ${scale * 10}px;
        left: ${scale * 9}px;
        border-radius: ${scale * 4}px;
      }
    }
    .pnlColumn-title {
      width: ${scale * 296}px !important;
    }
    .pnlColumn-time {
      min-width: ${scale * 80}px !important;
    }
    &,
    .hours,
    .minutes {
      letter-spacing: ${scale * 1}px;
    }
    .minutes {
      width: ${scale * 40}px !important;
    }
    [class*="HeaderRowCellStyles"] {
      font-size: ${scale * 14}px;
      height: ${scale * 26}px;
      min-height: ${scale * 26}px;
      max-height: ${scale * 26}px;
      margin: ${scale * 20}px 0 ${scale * 10}px 0;
      padding: ${scale * 6}px;
      &.leftMost {
        padding-left: ${scale * 20}px;
        border-top-left-radius: ${scale * 4}px;
        border-bottom-left-radius: ${scale * 4}px;
      }
    }
    [class*="DataRowCellStyles"] {
      font-size: ${scale * 14}px;
      height: ${scale * 26}px !important;
      min-height: ${scale * 26}px !important;
      padding: ${scale * 3}px ${scale * 6}px;
      letter-spacing: ${scale * 0.8}px;
    }
    [class*="PnlChartColumnsStyles__PnlBarStyles"] {
      height: ${scale * 16}px;
    }
  }
`;

export const getTilesTimelineTabsResponsiveStyles = (scale: number) => css`
  [data-component-name="Tiles/Timeline Tabs"] {
    header.appBar {
      height: ${scale * 54}px;
    }
    .MuiTab-root {
      font-size: ${scale * 24}px;
      min-width: ${scale * 160}px;
      padding: ${scale * 12}px ${scale * 16}px;
    }
    .MuiTabs-indicator {
      height: ${scale * 5}px;
    }
  }
`;

export const getGroupTilesResponsiveStyles = (
  scale: number,
  tileWidthConfig?: number
) => css`
  [data-component-name="Group Tiles Panel"] {
    grid-template-columns: repeat(
      auto-fit,
      ${scale * ((tileWidthConfig ?? 1) * TILE_WIDTH_PX_SM)}px
    );
    grid-template-rows: repeat(auto-fit, ${scale * TILE_WIDTH_PX_SM}px);
    grid-gap: ${scale * 5}px;
    margin-top: ${scale * 1}em;
    margin-bottom: ${scale * 1}em;
    .group-tile {
      width: ${scale * ((tileWidthConfig ?? 1) * TILE_WIDTH_PX_SM)}px;
      height: ${scale * TILE_WIDTH_PX_SM}px;
    }
    .group-name {
      font-size: ${scale * 1.15}rem;
    }
    .group-performance {
      font-size: ${scale * 2.6}rem;
    }
  }
`;
export const getProcessTilesResponsiveStyles = (scale: number) => css`
  [class*="ProcessTilesControls__ProcessTilesControlsStyles"] {
    left: ${scale * 16}px;
    right: ${scale * 24}px;
    top: ${scale * 16}px;
    .btnProcessTilesDropdown {
      height: fit-content;
      &:first-child {
        margin-right: ${scale * 8}px;
      }
    }
    .MuiSvgIcon-root {
      font-size: ${scale * 28}px;
    }
    .MuiInputBase-root {
      height: ${scale * 30}px;
    }
    .searchInput {
      margin-left: ${scale * 16}px;
      .MuiSvgIcon-root {
        width: ${scale * 20}px;
        height: ${scale * 20}px;
      }
      input {
        font-size: ${scale * 16}px;
        height: ${scale * 30}px;
      }
    }
    .btnProcessTilesDropdown {
      font-size: ${scale * 16}px;
      padding: ${scale * 5}px ${scale * 8}px;
      .MuiButton-startIcon .MuiSvgIcon-root {
        font-size: ${scale * 20}px;
      }
      .MuiButton-endIcon .MuiSvgIcon-root {
        font-size: ${scale * 20}px;
        padding: ${scale * 4}px;
        margin: ${scale * -5}px;
        margin-left: ${scale * 5}px;
      }
    }
  }
  .bottomRow {
    padding: ${scale * 16}px;
  }
  [class*="ProcessTilesFilterIndicator__ProcessTilesFilterIndicatorStyles"] {
    font-size: ${scale * 16}px;
    height: ${scale * 32}px;
    .filtersLabel {
      margin-right: ${scale * 26}px;
    }
    .filtersRow {
      .MuiChip-root {
        font-size: ${scale * 14}px;
        height: ${scale * 32}px;
        border-radius: ${scale * 8}px;
        margin-right: ${scale * 18}px;
        padding: ${scale * 10}px ${scale * 4}px ${scale * 10}px ${scale * 10}px;
      }
      .MuiChip-deleteIcon {
        width: ${scale * 20}px;
        height: ${scale * 20}px;
      }
      .category-circle {
        width: ${scale * 12}px;
        height: ${scale * 12}px;
        margin-right: ${scale * 8}px;
      }
      .btnClearAllFilters {
        font-size: ${scale * 14}px;
        line-height: ${scale * 17}px;
        padding: ${scale * 5}px ${scale * 10}px;
        border-radius: ${scale * 8}px;
      }
    }
  }
  .tilesCard {
    padding-top: ${scale * 108}px;
  }
  [data-component-name="Process Tiles Panel"] {
    /* ! disabled because sbdwarrington likes to view all their 100+ tiles at once on a large screen */
    .tile-container {
      .tile-divider {
        height: ${scale * 1}px;
      }
      .lessThanOne .svgWrapper {
        transform: scale(${scale * 0.6});
        transform-origin: bottom right;
      }
      [class*="ExpandedTileModules__SingleLineModuleStyles"] {
        height: ${scale * 27}px;
        font-size: ${scale * 12}px;
      }
      [class*="ExpandedTileModules__DoubleLineModuleStyles"] {
        height: ${scale * 41}px;
        &,
        .line-2 {
          font-size: ${scale * 12}px;
        }
      }
      [class*="TileMetricPercentModule__StyledDiv"] {
        padding: 0 0.1em;
      }
      [class*="TileAheadBehindModule__TileAheadBehindModuleStyles"] {
        height: ${scale * 66}px;
        padding: ${scale * 5}px;
        .aheadBehindAmount {
          font-size: ${scale * 15}px;
        }
        .actualVsExpected {
          .actual,
          .expected {
            .value {
              font-size: ${scale * 12}px;
              line-height: ${scale * 16}px;
            }
            .description {
              font-size: ${scale * 9}px;
              line-height: ${scale * 12}px;
            }
          }
        }
      }
    }
  }
  [class*="TileButterflyModule__TileButterflyStyles"] {
    height: ${scale * 16}px;
    .gaugeSpacer {
      width: ${scale * 2}px;
    }
    .gaugeMarker {
      width: ${scale * 6}px;
      height: ${scale * 9}px;
      border-radius: ${scale * 1}px;
      left: ${scale * -2}px;
      bottom: ${scale * -3}px;
    }
  }
`;

export const getMachineBreakdownChartResponsiveStyles = (scale: number) => css`
  [data-component-name="Machine Breakdown Chart"] {
    font-size: ${scale * 15}px;
    max-width: ${scale * 1200}px;
    [class*="TitleRow__TitleRowStyles"] {
      padding: ${scale * 16}px ${scale * 24}px 0 ${scale * 24}px;
    }
    .machineTitle {
      width: ${scale * 100}px;
    }
    .spacer {
      width: ${scale * 20}px;
    }
    .title:not(.tagBreakdownTitle) {
      width: ${scale * 75}px;
    }
    .btnMachineBreakdownRow {
      padding: ${scale * 16}px ${scale * 24}px;
      height: ${scale * 60}px;
      font-size: ${scale * 0.875}rem;
    }
    [class*="ProcessNameLink__ProcessNameLinkStyles"] {
      width: ${scale * 100}px;
      .processName {
        font-size: ${scale * 17}px;
      }
    }
    [class*="HorizontalBarstack__HorizontalBarstackStyles"] {
      height: ${scale * 26}px;
    }
    .barstackSpacer {
      width: ${scale * 9}px;
      height: ${scale * 28}px;
    }
  }
`;

export const GlobalResponsiveStyles = createGlobalStyle<{
  $scale: number;
}>`
@media (min-width: ${BREAKPOINT_DESKTOP_XL}px){
  .rangeSelectorConfigMenu {
    transform: scale(${props => props.$scale});
    transform-origin: top right;
  }
  .leftDrawer .bottom-of-drawer-list {
    margin-top: 0 !important;
  }
  .MuiDrawer-paperAnchorLeft {
    overflow: auto;
  }
}
`;
export const GlobalPopupMenuResponsiveStyles = createGlobalStyle<{
  $scale: number;
}>`
  &&&&&&&&&&&& {
    #process-tiles-sort-controls, #process-tiles-filter-controls {
      .MuiPopover-paper {
        transform: scale(${props => props.$scale * 0.8}) !important;
      }
    }
    #process-tiles-config {
      transform: scale(${props => props.$scale * 0.8}) !important;
      transform-origin: top left;
    }
    .highlightTagsPaper {
      transform: scale(${props => props.$scale * 0.8}) !important;
      transform-origin: bottom left;
    }
    .machineSwitcherPaper {
      transform: scale(${props => props.$scale * 0.8}) !important;
      transform-origin: top center;;
    }
    .MuiTooltip-popper .MuiTooltip-tooltip {
      transform: scale(${props => props.$scale * 1}) !important;
    }
    .btnOpenConfigTooltip.MuiTooltip-popper .MuiTooltip-tooltip {
      transform-origin: top right;
    }
    .backButtonTooltip.MuiTooltip-popper .MuiTooltip-tooltip {
      transform-origin: top left;
    }
    .processNameTooltip.MuiTooltip-popper .MuiTooltip-tooltip {
      transform-origin: top left;
      transform: translateX(${props => props.$scale * -22}px) scale(${props =>
        props.$scale * 1}) !important;
    }
    .MuiDrawer-paper {
      overflow: hidden;
    }

    ${props => getPnlChartResponsiveStyles(props.$scale)}
    ${props => getPnlPopupChartResponsiveStyles(props.$scale)}
    ${props => getGroupMetricsResponsiveStyles(props.$scale)}
    ${props => getTimelineChartResponsiveGlobalStyles(props.$scale)}
    
 
  }
`;

export const getHubletViewResponsiveStyles = (scale: number) => css``;
